import React from 'react';
import { useParams, Link } from 'react-router-dom';
import projectData from '../data/projectData';
import '../styles/ProjectDetail.css';

const ProjectDetail = () => {
  const { id } = useParams();
  const project = projectData.find((p) => p.id.toString() === id);

  if (!project) return <p>Project not found.</p>;

  return (
    <div className="project-detail">
      <div className="container">
        <h1>{project.title}</h1>
        {/* <img src={project.image} alt={project.title} /> */}
        <p>{project.fullDesc}</p>
        <Link to="/portfolio" className="back-link">← Back to Portfolio</Link>
      </div>
    </div>
  );
};

export default ProjectDetail;